import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';

import LoadingScreen from '../../components/LoadingScreen';
import { useAuth } from '../../utils/useAuth';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardHeader: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main,
  },
  textField: {
    margin: theme.spacing(1),
    width: '50%',
  },
  cardContent: {
    padding: theme.spacing(4),
  },
  cardActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    padding: theme.spacing(0, 4),
  },
}));

const SignIn = (props) => {
  const auth = useAuth();
  const classes = useStyles();
  const history = useHistory();

  const { handleSubmit, register, errors, setError } = useForm();

  function handleSignIn(data) {
    const { email, password } = data;

    auth
      .signin(email, password)
      .then((user) => {
        history.push('/');
      })
      .catch(({ code }) => {
        if (code === 'auth/wrong-password') {
          setError('password', {
            message: 'The password entered is incorrect',
          });
        } else if (code === 'auth/user-not-found') {
          setError('email', {
            message: 'No user with that email was found',
          });
        }
      });
  }

  if (auth.userIsLoading) {
    return <LoadingScreen />;
  }

  return auth.user ? (
    <Redirect
      to={props.location.state ? props.location.state.from : '/'}
      noThrow
    />
  ) : (
    <Container>
      <Grid className={classes.root} container>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardHeader
              className={classes.cardHeader}
              title="TSNW Volunteer Time Tracker"
              subheader={<Typography>Sign in to your account!</Typography>}
            ></CardHeader>
            <CardContent className={classes.cardContent}>
              <form id="sign-in-form" onSubmit={handleSubmit(handleSignIn)}>
                <TextField
                  error={!!errors.email}
                  helperText={!!errors.email && errors.email.message}
                  fullWidth
                  inputRef={register({
                    required: {
                      value: true,
                      message: 'Please enter your email.',
                    },
                  })}
                  label="Email Address"
                  name="email"
                  style={{ marginTop: '16px' }}
                  type="email"
                  variant="outlined"
                ></TextField>
                <TextField
                  error={!!errors.password}
                  helperText={!!errors.password && errors.password.message}
                  fullWidth
                  id="password"
                  inputRef={register({
                    required: {
                      value: true,
                      message: 'Please enter a password.',
                    },
                  })}
                  label="Password"
                  name="password"
                  style={{ marginTop: '16px' }}
                  type="password"
                  variant="outlined"
                ></TextField>
              </form>
            </CardContent>
            <CardActions className={classes.cardActions}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    form="sign-in-form"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Sign In
                  </Button>
                </Grid>
                <Grid item>
                  <Link href="/password-reset">
                    <Typography>Forgot your password?</Typography>
                  </Link>
                </Grid>
              </Grid>
              <div style={{ padding: '16px 0', margin: 0, display: 'flex' }}>
                <Typography style={{ marginRight: '4px' }}>
                  Don&#39;t have an account? Sign up{' '}
                </Typography>
                <Link href="/signup">
                  <Typography> here.</Typography>
                </Link>
              </div>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SignIn;
